import merge from 'deepmerge';
import {fetchAdvisers} from 'providers/core/advisers';
import {useEffect} from 'react';
import {useQuery, queryCache} from 'react-query';
import {overwriteMerge} from 'utils/deep-merge';

const staleTime = 5 * 60 * 1000;

export function useAdviser(id, forceUpdate = false) {
  const queryKey = ['adviser', id];

  useEffect(() => {
    if (forceUpdate) {
      queryCache.invalidateQueries(queryKey, {
        exact: true,
        refetchInactive: true,
      });
    }
  }, [forceUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return useQuery(
    queryKey,
    async () => {
      try {
        const {advisers} = await fetchAdvisers({
          adviserUserId: id,
        });

        return advisers[0] || null;
      } catch (e) {
        if (e.code === 'INVALID_REQUEST') {
          return null;
        }
        throw e;
      }
    },
    {
      staleTime,
    },
  );
}

export function putAdviserInCache(adviser) {
  const queryKey = ['adviser', adviser.userId];
  queryCache.setQueryData(queryKey, adviser, {
    staleTime,
  });
}

export function updateAdviserInCache(id, payload) {
  const queryKey = ['adviser', id];
  const data = queryCache.getQueryData(queryKey);

  if (data) {
    putAdviserInCache(
      merge(data, payload, {
        arrayMerge: overwriteMerge,
      }),
    );
  }
}
